import storeFileService from './store-file-service'

const baseUrl = '/api/customer/creator-asset'

export default {
    store: (opts) => {
        return storeFileService.store(opts, baseUrl)
    },
}
